import { NextPage } from 'next'
import { redirect } from 'next/navigation'
import { useRouter } from 'next/router'
import { useEffect } from 'react'

const Hpb: NextPage = () => {
  const router = useRouter()
  useEffect(() => {
    router.push('/prostata-aumentada')
  }, [router])

  return null
}

export default Hpb
